/* Doxa Passion V2 — interactions globales
   - Ajout panier AJAX depuis les cartes produit (+ → stepper − qté +)
   - Mise à jour du badge panier
   - Onglets "meilleures ventes"
   - Menus déroulants (burger / compte)
*/
(function () {
  'use strict';

  /* ---------- Badge panier ---------- */
  function setCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  /* ---------- Animation : le produit s'envole vers le panier ---------- */
  function flyToCart(card) {
    var img = card.querySelector('.dx-card2__media img');
    var cart = document.querySelector('.dx-cart2');
    if (!img || !cart || !img.getBoundingClientRect) return;
    var r = img.getBoundingClientRect();
    var c = cart.getBoundingClientRect();
    if (r.width === 0 || c.width === 0) return;
    var clone = img.cloneNode(true);
    clone.style.cssText = 'position:fixed;z-index:9999;left:' + r.left + 'px;top:' + r.top + 'px;width:' + r.width + 'px;height:' + r.height + 'px;border-radius:12px;object-fit:cover;pointer-events:none;margin:0;transition:none;box-shadow:0 12px 30px rgba(29,64,56,.3)';
    document.body.appendChild(clone);
    var dx = (c.left + c.width / 2) - (r.left + r.width / 2);
    var dy = (c.top + c.height / 2) - (r.top + r.height / 2);
    var anim = clone.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1 },
      { transform: 'translate(' + (dx * 0.5) + 'px,' + (dy * 0.5 - 80) + 'px) scale(.45)', opacity: .95, offset: .55 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.1)', opacity: .35 }
    ], { duration: 700, easing: 'cubic-bezier(.45,-.15,.7,.35)' });
    anim.onfinish = function () {
      clone.remove();
      cart.animate([
        { transform: 'scale(1)' },
        { transform: 'scale(1.3)' },
        { transform: 'scale(1)' }
      ], { duration: 300, easing: 'ease-out' });
    };
  }

  /* ---------- Cartes produit : + / stepper ---------- */
  function cardOf(el) { return el.closest('.dx-card2'); }

  function showQtyUI(card, qty) {
    var add = card.querySelector('[data-add]');
    var ui = card.querySelector('[data-qty-ui]');
    if (!ui) return;
    if (qty > 0) {
      var wasHidden = ui.hidden;
      if (add) add.hidden = true;
      ui.hidden = false;
      if (wasHidden) {
        ui.classList.remove('dx-anim-pop');
        void ui.offsetWidth;
        ui.classList.add('dx-anim-pop');
      }
      ui.querySelector('[data-count]').textContent = qty;
    } else {
      if (add) add.hidden = false;
      ui.hidden = true;
    }
  }

  function updateVariantQty(card, qty) {
    var variantId = card.getAttribute('data-variant');
    if (!variantId) return;
    card.classList.add('is-busy');
    var updates = {};
    updates[variantId] = Math.max(0, qty);
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart/update.js ' + r.status);
        return r.json();
      })
      .then(function (cart) {
        var line = cart.items.find(function (i) { return String(i.variant_id) === String(variantId); });
        showQtyUI(card, line ? line.quantity : 0);
        setCartCount(cart.item_count);
      })
      .catch(function () {
        // En cas d'échec (produit avec plan d'abonnement, etc.) on bascule vers la fiche produit.
        var link = card.querySelector('.dx-card2__name');
        if (link) window.location.href = link.href;
      })
      .finally(function () { card.classList.remove('is-busy'); });
  }

  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-add]');
    if (addBtn && cardOf(addBtn)) {
      e.preventDefault();
      flyToCart(cardOf(addBtn));
      updateVariantQty(cardOf(addBtn), 1);
      return;
    }
    var plus = e.target.closest('[data-plus]');
    if (plus && cardOf(plus)) {
      e.preventDefault();
      var cardP = cardOf(plus);
      var qP = parseInt(cardP.querySelector('[data-count]').textContent, 10) || 0;
      flyToCart(cardP);
      updateVariantQty(cardP, qP + 1);
      return;
    }
    var minus = e.target.closest('[data-minus]');
    if (minus && cardOf(minus)) {
      e.preventDefault();
      var cardM = cardOf(minus);
      var qM = parseInt(cardM.querySelector('[data-count]').textContent, 10) || 0;
      updateVariantQty(cardM, qM - 1);
      return;
    }
  });

  /* ---------- Onglets meilleures ventes ---------- */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('.dx-tab[data-tab]');
    if (!tab) return;
    var root = tab.closest('[data-tabs-root]');
    if (!root) return;
    root.querySelectorAll('.dx-tab').forEach(function (t) { t.classList.remove('is-active'); });
    tab.classList.add('is-active');
    root.querySelectorAll('.dx-tabpanel').forEach(function (p) {
      p.hidden = p.getAttribute('data-panel') !== tab.getAttribute('data-tab');
    });
  });

  /* ---------- Animations : révélation au scroll + cascade des grilles ---------- */
  (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;
    var singles = ['.dx-sec__head', '.dx-ctaban__card', '.dx-duoban', '.dx-arch__head', '.dx-faqhome__media', '.dx-faqhome__list', '.dx-shopcta', '.dx-article__card', '.dx-formcard'];
    var grids = ['.dx-grid-4', '.dx-cats__grid', '.dx-promos__grid', '.dx-blog__grid', '.dx-arch__grid', '.dx-testi__grid', '.dx-grid-ev'];
    var targets = [];
    singles.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) { targets.push(el); });
    });
    grids.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (grid) {
        Array.prototype.forEach.call(grid.children, function (child, i) {
          child.style.setProperty('--dx-reveal-delay', (i % 8) * 0.08 + 's');
          targets.push(child);
        });
      });
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-inview'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    targets.forEach(function (el) {
      var r = el.getBoundingClientRect();
      // Déjà visible au chargement (ou dans un panneau caché) : ne pas masquer.
      if (r.top < window.innerHeight * 0.85) return;
      el.setAttribute('data-reveal', '');
      io.observe(el);
    });
  })();

  /* ---------- Nav compacte au scroll + hauteur réelle du header ---------- */
  (function () {
    var header = document.querySelector('.dx-header');
    if (!header) return;
    var compact = false;
    // Les barres collantes (filtres boutique) se calent sur la hauteur RÉELLE
    // du header (qui change en mode compact et selon l'écran), moins 6px de
    // chevauchement pour qu'aucune fente ne laisse voir le contenu.
    function setVar() {
      document.documentElement.style.setProperty('--dx-header-h', (header.offsetHeight - 6) + 'px');
    }
    setVar();
    window.addEventListener('load', setVar);
    window.addEventListener('resize', setVar, { passive: true });
    window.addEventListener('scroll', function () {
      var c = (window.scrollY || 0) > 90;
      if (c !== compact) {
        compact = c;
        header.classList.toggle('is-compact', c);
        // la hauteur change avec une transition de 250ms : re-mesurer après
        setTimeout(setVar, 300);
      }
    }, { passive: true });
  })();

  /* ---------- Doodles du héro : parallaxe à la souris (desktop) ---------- */
  (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var card = document.querySelector('.dx-hero2__card');
    var deco = card && card.querySelector('.dx-hero2__deco');
    if (!deco) return;
    var raf = null;
    card.addEventListener('mousemove', function (e) {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var r = card.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width - 0.5) * 16;
        var y = ((e.clientY - r.top) / r.height - 0.5) * 12;
        deco.style.transform = 'translate(' + x + 'px,' + y + 'px)';
      });
    });
    card.addEventListener('mouseleave', function () { deco.style.transform = ''; });
  })();

  /* ---------- Fiche produit : rebond du prix au changement de formule ---------- */
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'selling_plan') {
      var pr = document.querySelector('.dx-pdp__price');
      if (pr) { pr.classList.remove('dx-anim-bounce'); void pr.offsetWidth; pr.classList.add('dx-anim-bounce'); }
    }
  });

  /* ---------- Recherche prédictive (produits en priorité, puis blog) ---------- */
  (function () {
    var input = document.querySelector('.dx-searchpanel input[type="search"]');
    var box = document.querySelector('[data-suggest]');
    if (!input || !box) return;
    var timer = null;
    var lastQ = '';

    function esc(s) {
      var d = document.createElement('div');
      d.textContent = s;
      return d.innerHTML;
    }
    function money(p) { return String(p).replace('.', ',') + '€'; }

    function renderPopular() {
      var pop = (box.getAttribute('data-popular') || '').split(',')
        .map(function (s) { return s.trim(); })
        .filter(function (s) { return s.length; });
      if (!pop.length) { box.hidden = true; return; }
      box.innerHTML = '<div class="dx-suggest__h">Recherches populaires</div>' + pop.map(function (t) {
        return '<a class="dx-suggest__q" href="/search?q=' + encodeURIComponent(t) + '">' + esc(t) + '</a>';
      }).join('');
      box.hidden = false;
    }

    function render(d, q) {
      var res = (d.resources && d.resources.results) || {};
      var products = res.products || [];
      var queries = res.queries || [];
      var articles = res.articles || [];
      if (!products.length && !queries.length && !articles.length) {
        box.innerHTML = '<div class="dx-suggest__empty">Aucun résultat pour « ' + esc(q) + ' »</div>';
        box.hidden = false;
        return;
      }
      var left = '';
      if (queries.length) {
        left += '<div class="dx-suggest__h">Suggestions</div>' + queries.map(function (x) {
          return '<a class="dx-suggest__q" href="' + x.url + '">' + (x.styled_text || esc(x.text)) + '</a>';
        }).join('');
      }
      if (articles.length) {
        left += '<div class="dx-suggest__h">Sur le blog</div>' + articles.slice(0, 3).map(function (a) {
          return '<a class="dx-suggest__q" href="' + a.url + '">' + esc(a.title) + '</a>';
        }).join('');
      }
      var right = '';
      if (products.length) {
        right = '<div class="dx-suggest__h">Produits</div>' + products.map(function (p) {
          return '<a class="dx-suggest__p" href="' + p.url + '">' +
            (p.image ? '<img src="' + p.image + '" alt="" width="44" height="44" loading="lazy">' : '') +
            '<span><span class="t">' + esc(p.title) + '</span><span class="pr">' + money(p.price) + '</span></span></a>';
        }).join('');
      }
      var two = left && right;
      box.innerHTML = '<div class="dx-suggest__grid' + (two ? ' has-two' : '') + '">' +
        (left ? '<div>' + left + '</div>' : '') +
        (right ? '<div>' + right + '</div>' : '') +
        '</div>' +
        '<a class="dx-suggest__all" href="/search?q=' + encodeURIComponent(q) + '">Voir tous les résultats</a>';
      box.hidden = false;
    }

    input.addEventListener('focus', function () {
      if (input.value.trim().length < 2) renderPopular();
    });

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { renderPopular(); return; }
      timer = setTimeout(function () {
        lastQ = q;
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product,query,article&resources[limit]=5' +
          '&resources[options][unavailable_products]=hide')
          .then(function (r) { return r.json(); })
          .then(function (d) { if (q === lastQ) render(d, q); })
          .catch(function () {});
      }, 220);
    });
  })();

  /* ---------- Pastilles catégories : indice de défilement ---------- */
  (function () {
    document.querySelectorAll('.dx-catnav').forEach(function (nav) {
      var row = nav.querySelector('.dx-catnav__in');
      if (!row) return;
      function update() {
        var end = row.scrollLeft + row.clientWidth >= row.scrollWidth - 8;
        var scrollable = row.scrollWidth > row.clientWidth + 8;
        nav.classList.toggle('is-end', end || !scrollable);
      }
      row.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    });
  })();

  /* ---------- Menus déroulants (burger, compte) ---------- */
  document.querySelectorAll('.dx-dd > [data-dd-toggle]').forEach(function (t) {
    t.addEventListener('click', function (e) {
      e.preventDefault();
      var dd = t.closest('.dx-dd');
      document.querySelectorAll('.dx-dd.is-open').forEach(function (o) { if (o !== dd) o.classList.remove('is-open'); });
      dd.classList.toggle('is-open');
      if (dd.classList.contains('is-open')) {
        var inp = dd.querySelector('input[type="search"]');
        if (inp) setTimeout(function () { inp.focus(); }, 60);
      }
    });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.dx-dd')) {
      document.querySelectorAll('.dx-dd.is-open').forEach(function (o) { o.classList.remove('is-open'); });
    }
  });
})();
